import { BlockValueRemover, BlockValuesUpdater } from '../../hooks/blockValues';
import React, { useEffect } from 'react';
import { ScopeT, UserScopesT } from 'business/definitions';

import PermissionValuesEditor from '../PermissionEditor/PermissionValuesEditor';
import { getSelectedValuesOfTreeTablePicker } from 'routes/Admin/UserManagement/Users/helpers';
import { optionsToFlatTree } from 'components/inputs/TreeTablePicker/helpers';
import { sortTreeByChildrenLabel } from 'helpers/treeHelpers';
import { useFetchScopeTree } from '../../hooks/scopeTree';

interface BlockEditorProps {
    scope: ScopeT;
    userScopes: UserScopesT;
    block: string;
    onUpdateBlockValues: BlockValuesUpdater;
    onRemoveBlockValue: BlockValueRemover;
}

const BlockEditor = ({
    scope,
    userScopes,
    block,
    onUpdateBlockValues,
    onRemoveBlockValue,
}: BlockEditorProps) => {
    const [treeOptions, setTreeOptions] = React.useState<TreeT | null>(null);
    const { data: scopeTree, isLoading } = useFetchScopeTree(block);

    useEffect(() => {
        if (scopeTree) {
            const { treeValues, values } = scopeTree;
            const gridOptions =
                treeValues !== null ? treeValues : optionsToFlatTree(values);
            const sortedGridOptions = sortTreeByChildrenLabel(
                gridOptions,
                false,
            );
            setTreeOptions(sortedGridOptions);
        }
    }, [scopeTree]);

    const selectedValues = getSelectedValuesOfTreeTablePicker(
        scopeTree?.treeValues ?? null,
        scopeTree?.values ?? [],
        { block, operation: 'in' },
        scope,
        userScopes,
    );

    return (
        <PermissionValuesEditor
            field={block}
            selectedValues={selectedValues}
            tree={treeOptions}
            onSubmit={onUpdateBlockValues}
            onDelete={onRemoveBlockValue}
            isLoading={isLoading}
        />
    );
};

export default BlockEditor;
